import { render, staticRenderFns } from "./MemberProfile.vue?vue&type=template&id=06e4e2ab&"
import script from "./MemberProfile.vue?vue&type=script&lang=js&"
export * from "./MemberProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports